import { Box, Divider } from '@mui/material';
import React from 'react';
import useScreenSize from '../../../../utils/useScreenSize';

const SingleSearchResultContainer: React.FC = (props) => {
  const { isSmallScreen } = useScreenSize();
  return (
    <React.Fragment>
      {props.children}
      {isSmallScreen && (
        <Box>
          <Divider
            component='div'
            sx={{
              minWidth: 'min(100%, 743px)',
              position: 'absolute',
              left: 0,
            }}
          />
        </Box>
      )}
    </React.Fragment>
  );
};

export default SingleSearchResultContainer;
